import React from 'react';
import { FadeIn } from '../ui/FadeIn';

const statements = [
  {
    title: 'Mission',
    desc: 'To bring the warmth and soul of a French bistro together with the precision of fine dining — creating a Muslim Owned dining experience that is both approachable and extraordinary, where every guest feels truly at home.',
  },
  {
    title: 'Vision',
    desc: 'To be recognised as Singapore\'s most beloved Muslim Owned French bistro — a place where tradition and refinement meet, inspiring a new standard for approachable fine dining experiences.',
  },
];

export const DiningExperience = () => (
  <section className="py-28 md:py-40 relative overflow-hidden">
    <div className="absolute inset-0 z-0">
      <div className="absolute inset-0 bg-charcoal/90 z-10" />
      <img 
        src="https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1779381068/Landscape___Create_a_premium_restaurant_food_showcase_collage_using_8_different_food_photographs_from_Maison_De_Charm.__The_final_composition_should_feel_elegant__luxurious__modern__and_suitable_for_a_high-end_restaurant_website_homepage_or_kkpvbk.png" 
        alt="Bistro Experience Collage" 
        className="w-full h-full object-cover" 
      />
    </div>
    <div className="container mx-auto px-6 md:px-14 relative z-20">
      <FadeIn className="text-center mb-20">
        <h2 className="font-serif text-4xl md:text-5xl text-white">Our Statements</h2>
      </FadeIn>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 max-w-5xl mx-auto">
        {statements.map((s, i) => (
          <FadeIn key={i} delay={i * 0.15} direction="up">
            <div className="bg-charcoal/40 backdrop-blur-md p-12 md:p-16 h-full text-center group hover:bg-wine/20 transition-colors duration-700">
              <h3 className="font-serif text-2xl text-gold mb-6 tracking-wide uppercase">{s.title}</h3>
              <div className="w-12 h-px bg-gold/40 mx-auto mb-8 group-hover:w-20 transition-all duration-700" />
              <p className="text-white/70 font-light text-base leading-relaxed max-w-md mx-auto italic">
                "{s.desc}"
              </p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);